module.exports = __webpack_public_path__ + "media/images/landing_page/banners/banner_three-85ff281b9f2883d7eeb356dcbe35d665.jpg";